import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthService, WishListService } from '@spartacus/core';
import {
  AddToWishListComponent,
  CurrentProductService,
} from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ProductService } from '../../product/service/product.service';

@Component({
  selector: 'add-ek-wishlist',
  templateUrl: './add-ek-wishlist.component.html',
  styleUrls: ['./add-ek-wishlist.component.scss'],
})
export class AddEkWishlistComponent
  extends AddToWishListComponent
  implements OnInit
{
  userId: any;
  product: any;
  productCode: any;
  wishListEntries: any[] = [];
  isAddedInWishList: boolean = false;
  constructor(
    protected wishListFacade: WishListService,
    protected currentProductService: CurrentProductService,
    protected authService: AuthService,
    protected userAccount: UserAccountFacade,
    protected productService: ProductService,
    protected cd: ChangeDetectorRef
  ) {
    super(wishListFacade, currentProductService, authService);
  }

  ngOnInit(): void {
    this.productService.productCode.subscribe((resp) => {
      console.log("xxx",resp);
      if (resp) {
        this.product = resp;
        this.checkWhetherProductIsPresent();
      }
    });
    this.userAccount.get().subscribe((resp) => {
      this.userId = resp?.uid;
    });
    if (this.userId !== undefined) {
      this.productService
        .getWishlistResults(this.userId)
        .subscribe((wishList: any) => {
          this.wishListEntries = wishList?.entries;
          this.checkWhetherProductIsPresent();
        });
    }
  }

  checkWhetherProductIsPresent() {
    this.isAddedInWishList =
      this.wishListEntries?.findIndex(
        (entry: any) => entry?.product?.code === this.product
      ) !== -1
        ? true
        : false;
    this.cd.detectChanges();
  }

  addEntry(item: any) {
    this.productService
      .addWishlistEntry(this.userId, item)
      .subscribe((resp) => {
        this.wishListEntries = resp?.entries;
        this.checkWhetherProductIsPresent();
      });
  }

  removeEntry(item: any) {
    this.productService
      .removeWishlistEntry(this.userId, item)
      .subscribe((resp) => {
        this.isAddedInWishList = false;
        this.cd.detectChanges();
      });
  }
}
